exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".beta-modal .modal-content{border-radius:10}.beta-modal .primary-button{background-color:#16a085;color:#fff;border-radius:5px;padding:10px 15px}.beta-modal .primary-button:hover{background-color:#047857}.beta-modal .cancel-button{border:2px solid #757575;color:#434343;padding:10px 15px;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/beta_modal.scss
// module id = 708
// module chunks = 0